// NodeList polyfill for IE
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function(callback, thisArg) {
		thisArg = thisArg || window;

		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

class GDPRConsentManager {

	constructor() {}

	readConsents() {
		let consents = {};

		document.cookie.split(";").some(cookie => {
			const key = cookie.split("=")[0].trim();
			const value = cookie.split("=")[1];

			if (key === "gdpr-consent") {
				consents = JSON.parse(decodeURIComponent(value));

				return true;
			}
		});

		return consents;
	}

	updateGTMConsents(preferences) {
		if (
			!window.consentModeV2 ||
			Object.keys(preferences).length === 0 ||
			typeof gtag === "undefined"
		) {
			return;
		}

		gtag("consent", "update", {
			ad_storage: this.getGTagConsentPreference(preferences?.marketing),
			ad_user_data: this.getGTagConsentPreference(preferences?.marketing),
			ad_personalization: this.getGTagConsentPreference(preferences?.marketing),
			analytics_storage: this.getGTagConsentPreference(preferences?.analytics)
		});
	}

	getGTagConsentPreference(value) {
		return value ? "granted" : "denied";
	}

	getConsentBannerElement() {
		return document.querySelector("#cookie-consent-container");
	}

	getConsentFormContainer() {
		return document.querySelector("#cookie-consent-form-container");
	}

	hasConsent(type) {
		var consents = this.readConsents();

		return consents[type] == true;
	}

	showCookieConsentBanner() {
		const consentBanner = this.getConsentBannerElement();

		if (!consentBanner) {
			return;
		}

		consentBanner.classList.remove("minimized");

		const bannerHeight = consentBanner.offsetHeight;

		document.querySelector("body").style.paddingBottom = `${bannerHeight}px`;
	}

	minimizeCookieConsentBanner() {
		if (document.cookie.indexOf("gdpr-consent") < 0) {
			this.getConsentFormContainer().querySelectorAll(".preference-selector input[type='checkbox']").forEach(cookie => {
				cookie.checked = false;
			});

			this.updateCookiePreferences();
		}

		this.getConsentBannerElement().classList.add("minimized");

		document.querySelector("body").style.paddingBottom = 0
	}

	openCookieConsentForm(target = null) {
		document.querySelector("html").scrollTop = 0

		document.querySelector("body").classList.add("consent-form-visible");

		this.getConsentFormContainer().style.display = "block";

		if (
			target &&
			target.dataset.target
		) {
			this.activateTab(target.dataset.target);
		}

		this.attachKeyupListener();
	}

	closeCookieConsentForm() {
		document.querySelector("body").classList.remove("consent-form-visible");

		this.getConsentFormContainer().style.display = "none";

		this.detachKeyupListener();
	}

	approveAllCookies() {
		this.getConsentFormContainer().querySelectorAll(".preference-selector input[type='checkbox']").forEach(cookie => {
			cookie.checked = true;
		});

		this.updateCookiePreferences();
	}

	rejectAllCookies() {
		this.getConsentFormContainer().querySelectorAll(".preference-selector input[type='checkbox']").forEach(cookie => {
			cookie.checked = false;
		});

		this.updateCookiePreferences();
	}

	activateTab(slug) {
		const consentFormContainer = this.getConsentFormContainer();
		const tab = consentFormContainer.querySelector(`.tab[data-target="${slug}"]`);

		if (tab === null) {
			return;
		}

		consentFormContainer.querySelectorAll(".tab[data-target]").forEach(tab => {
			tab.classList.remove("active");
		});

		consentFormContainer.querySelectorAll(".panel").forEach(panel => {
			panel.classList.remove("active");
		});

		tab.classList.add("active");

		consentFormContainer.querySelector("#" + tab.dataset.target).classList.add("active");
	}

	attachKeyupListener() {
		this._handleKeyUp = e => {
			var key = e.key || e.keyCode;

			if (
				key === "Escape" ||
				key === 27
			) {
				this.closeCookieConsentForm();
			}
		}

		window.addEventListener("keyup", this._handleKeyUp);
	}

	detachKeyupListener() {
		window.removeEventListener("keyup", this._handleKeyUp);
	}

	consentPreferenceUpdateCallback() {
		this.closeCookieConsentForm();
		this.minimizeCookieConsentBanner();
		this.replaceTags();
	}

	postPreferences(preferences) {
		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
			},
			body: new URLSearchParams(preferences),
		}

		const postEndpoint = "/gdpr";

		fetch(postEndpoint, options)
			.then(response => {
				if (response.ok) {
					this.consentPreferenceUpdateCallback()
				}
				else {
					console.error(response)

					alert("Unable to complete your request.")
				}
			})
	}

	updateCookiePreferences(jsEvent) {
		var preferences = {};

		this.getConsentFormContainer().querySelectorAll('.preference-selector input[type="checkbox"]').forEach(cookie => {
			preferences[cookie.name] = cookie.checked ? 1 : 0;
		});

		const container = this.getConsentBannerElement();
		const requireConsent = "requireConsent" in container.dataset;

		if (requireConsent) {
			this.postPreferences(preferences);

			this.updateGTMConsents(preferences);
		}
		else {
			document.cookie = "gdpr-consent={};path=/;secure";

			this.consentPreferenceUpdateCallback();
		}
	}

	replaceTag(element, type) {
		var newElement = document.createElement(type);

		for (var i = 0; i < element.attributes.length; i++) {
			newElement.setAttribute(element.attributes[i].nodeName, element.attributes[i].value);
		}

		if (element.nonce) {
			newElement.setAttribute("nonce", element.nonce);
		}

		element.childNodes.forEach(child => {
			newElement.appendChild(child);
		});

		return newElement;
	}

	replaceTags() {
		document.querySelectorAll("gdpr-iframe").forEach(element => {
			if (!element.dataset.consent) {
				console.warn("consent type not set for element", element);

				return;
			}

			if (this.hasConsent(element.dataset.consent)) {
				if (element.dataset.hasOwnProperty("id")) {
					const promptID = element.dataset.id
					const target = document.querySelector( `[data-prompt="${ promptID }"]` )

					if (target) {
						target.style.display = "none"
					}
				}

				var newTag = this.replaceTag(element, "iframe");

				element.parentNode.replaceChild(newTag, element);
			}
		});

		document.querySelectorAll('script[type="text/plain"]').forEach(element => {
			if (!element.dataset.consent) {
				console.warn("consent type not set for element", element);

				return;
			}

			if (this.hasConsent(element.dataset.consent)) {
				element.type = "text/javascript";

				var newTag = this.replaceTag(element, "script");

				element.parentNode.replaceChild(newTag, element);
			}
		});
	}

	prefillCookiePreferences() {
		var consents = this.readConsents();

		this.getConsentFormContainer().querySelectorAll('.preference-selector input[type="checkbox"]').forEach(checkbox => {
			var consentType = checkbox.name;

			checkbox.checked = consents[consentType] == true;
		});
	}

}

const consentManager = new GDPRConsentManager();

consentManager.updateGTMConsents(consentManager.readConsents());

document.addEventListener("DOMContentLoaded", function() {
	consentManager.replaceTags();

	var consentBanner = consentManager.getConsentBannerElement();
	var consentFormContainer = consentManager.getConsentFormContainer();

	if (
		consentBanner &&
		consentFormContainer
	) {
		try {
			document.querySelectorAll(".consent-banner-open-trigger").forEach(element => {
				element.addEventListener("click", event => {
					consentManager.showCookieConsentBanner();
				});
			});

			document.addEventListener("click", event => {
				const trigger = event.target.closest(".consent-more-trigger");

				if (
					trigger
				) {
					consentManager.openCookieConsentForm(trigger);
				}
			}, true);

			if (consentBanner.querySelector(".consent-all-trigger")) {
				consentBanner.querySelector(".consent-all-trigger").addEventListener("click", () => {
					consentManager.approveAllCookies();
				});
			}

			if (consentBanner.querySelector(".reject-all-trigger")) {
				consentBanner.querySelector(".reject-all-trigger").addEventListener("click", () => {
					consentManager.rejectAllCookies();
				});
			}

			if (consentBanner.querySelector(".consent-dismiss-trigger")) {
				consentBanner.querySelector(".consent-dismiss-trigger").addEventListener("click", () => {
					consentManager.minimizeCookieConsentBanner();
				});
			}

			if (consentFormContainer.querySelector(".consent-form-dismiss-trigger")) {
				consentFormContainer.querySelector(".consent-form-dismiss-trigger").addEventListener("click", () => {
					consentManager.closeCookieConsentForm();
				});
			}

			if (consentFormContainer.querySelector(".consent-submit-trigger")) {
				consentFormContainer.querySelector(".consent-submit-trigger").addEventListener("click", () => {
					consentManager.updateCookiePreferences();
				});
			}

			consentFormContainer.querySelectorAll(".tab[data-target]").forEach(tab => {
				tab.addEventListener("click", function(el) {
					consentManager.activateTab(el.currentTarget.dataset.target);
				});
			});

			// If the user has not made a decision, show them the banner
			// If they have made a decision they can continue to see the gear icon that allows them to change their preferences
			if (document.cookie.indexOf("gdpr-consent") < 0) {
				setTimeout(() => {
					consentManager.showCookieConsentBanner();
				}, 5000);
			}

			consentManager.prefillCookiePreferences();
		}
		catch (exception) {
			console.group();
			console.error(exception);
			console.info("Consent Banner:", consentBanner);
			console.info("Consent Form Container:", consentFormContainer);
			console.groupEnd();
		}
	}
});
